export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function currentDateTime(value) {
  let current;

  try {
    // Check if value is provided and is a valid date
    if (value) {
      current = new Date(value);
      if (isNaN(current)) {
        current = new Date();
      }
    } else {
      current = new Date();
    }

    // Format month
    const month = current.getMonth() + 1;
    const currentMonth = month.toString().padStart(2, "0");

    // Format date
    const date = current.getDate().toString().padStart(2, "0");

    // Construct date string
    const dateString = `${current.getFullYear()}-${currentMonth}-${date}`;

    // Format time components
    const hours = current.getHours().toString().padStart(2, "0");
    const minutes = current.getMinutes().toString().padStart(2, "0");
    const seconds = current.getSeconds().toString().padStart(2, "0");

    // Construct time string
    const timeString = `${hours}:${minutes}:${seconds}`;

    // Combine date and time strings
    const dateTime = `${dateString} ${timeString}`;

    return dateTime;
  } catch (error) {
    console.error("An error occurred:", error.message);
    return null;
  }
}

export function convertDateTOFormat(value) {
  var dt = new Date(value);
  let dformat = `${padL(dt.getMonth() + 1)}-${padL(
    dt.getDate()
  )}-${dt.getFullYear()} ${padL(dt.getHours())}:${padL(dt.getMinutes())}:${padL(
    dt.getSeconds()
  )}`;
  return dformat;
}

export function getTimeDocumentDateTime(date) {
  const Xmas95 = new Date(date);
  const startTime = new Intl.DateTimeFormat(this.selectedLang, {
    timeStyle: "short",
  }).format(Xmas95);
  const day = new Date(Xmas95).toLocaleString(this.selectedLang, {
    weekday: "long",
  });
  const sDate = formatDate(Xmas95, "yyyy/MM/dd");
  return `${day} ${sDate} at ${startTime}`;
}
/* export function convertIntlDateFormat(date) {
  var arr = date.split(/[- :]/);
  var Xmas95 = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);

  //var Xmas95 = new Date(date);
  var options = { dateStyle: "medium", timeStyle: "medium", hour12: true };
  return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
} */

export function convertIntlDateFormat(date, locale) {
  try {
    // Validate date input
    if (!date || !date.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
      throw new Error(
        "Invalid date format. Expected format: 'YYYY-MM-DD HH:MM:SS'"
      );
    }

    // Split the date string into its components
    var arr = date.split(/[- :]/);
    var year = parseInt(arr[0], 10);
    var month = parseInt(arr[1], 10) - 1; // JavaScript months are 0-based
    var day = parseInt(arr[2], 10);
    var hour = parseInt(arr[3], 10);
    var minute = parseInt(arr[4], 10);
    var second = parseInt(arr[5], 10);

    // Create a new Date object
    var dateObj = new Date(year, month, day, hour, minute, second);
    if (isNaN(dateObj)) {
      throw new Error("Invalid date values. Unable to parse the date.");
    }

    // Options for Intl.DateTimeFormat
    var options = { dateStyle: "medium", timeStyle: "medium", hour12: true };

    // Return the formatted date string
    return new Intl.DateTimeFormat(locale, options).format(dateObj);
  } catch (error) {
    console.log(`Error: ${error.message}`);
    return date.toString();
  }
}

export function unixIntlDateFormat(locale, unix_timestamp) {
  var options = { dateStyle: "full", timeStyle: "medium", hour12: true };
  return new Intl.DateTimeFormat(locale, options).format(
    new Date(unix_timestamp * 1e3)
  );
}

export function isoIntlDateFormat(locale, isoString) {
  const options = { dateStyle: "full", timeStyle: "medium", hour12: true };
  return new Intl.DateTimeFormat(locale, options).format(new Date(isoString));
}

const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

export function currentToDate(value) {
  const current = new Date(value);
  const date =
    current.getFullYear() +
    "-" +
    (current.getMonth() + 1) +
    "-" +
    current.getDate();
  const dateTime = date;

  return dateTime;
}

export function currentToTime(value) {
  const current = new Date(value);
  const time =
    current.getHours() +
    ":" +
    current.getMinutes() +
    ":" +
    current.getSeconds();
  return time;
}

export function createUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function subtractFromDate(
  d_type = "",
  number,
  date = new Date(Date.now())
) {
  if (d_type == "day") {
    date.setDate(date.getDate() - number);
  } else if (d_type == "month") {
    date.setMonth(date.getMonth() - number);
  } else if (d_type == "year") {
    date.setYear(date.getFullYear() - number);
  }
  return date;
}

export function addIntoDate(d_type = "month", number, date = new Date()) {
  if (d_type == "day") {
    date.setDate(date.getDate() + number);
  } else if (d_type == "month") {
    date.setMonth(date.getMonth() + number);
  } else if (d_type == "year") {
    date.setYear(date.getYear() + number);
  }
  return date;
}

export function getContrast(hexcolor) {
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map(function (hex) {
        return hex + hex;
      })
      .join("");
  }

  // Convert to RGB value
  let r = parseInt(hexcolor.substr(0, 2), 16);
  let g = parseInt(hexcolor.substr(2, 2), 16);
  let b = parseInt(hexcolor.substr(4, 2), 16);

  // Get YIQ ratio
  let yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 128 ? "black" : "white";
}

export function formatDate(date, patternStr) {
  if (!patternStr) {
    patternStr = "MM/dd/yyyy";
  }
  var day = date.getDate(),
    month = date.getMonth(),
    year = date.getFullYear(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds(),
    miliseconds = date.getMilliseconds(),
    h = hour % 12;
  if (h === 0) {
    h = 12;
  }
  var hh = twoDigitPad(h),
    HH = twoDigitPad(hour),
    mm = twoDigitPad(minute),
    ss = twoDigitPad(second),
    aaa = hour < 12 ? "AM" : "PM",
    EEEE = dayOfWeekNames[date.getDay()],
    EEE = EEEE.substr(0, 3),
    dd = twoDigitPad(day),
    M = month + 1,
    MM = twoDigitPad(M),
    MMMM = monthNames[month],
    MMM = MMMM.substr(0, 3),
    yyyy = year + "",
    yy = yyyy.substr(2, 2);
  // checks to see if month name will be used
  patternStr = patternStr
    .replace("hh", hh)
    .replace("h", h)
    .replace("HH", HH)
    .replace("H", hour)
    .replace("mm", mm)
    .replace("m", minute)
    .replace("ss", ss)
    .replace("s", second)
    .replace("S", miliseconds)
    .replace("dd", dd)
    .replace("d", day)

    .replace("EEEE", EEEE)
    .replace("EEE", EEE)
    .replace("yyyy", yyyy)
    .replace("yy", yy);
  // .replace("aaa", aaa);
  if (patternStr.indexOf("MMM") > -1) {
    patternStr = patternStr.replace("MMMM", MMMM).replace("MMM", MMM);
  } else {
    patternStr = patternStr.replace("MM", MM).replace("M", M);
  }
  return patternStr.replace("aaa", aaa);
}

function twoDigitPad(num) {
  return num < 10 ? "0" + num : num;
}

export function setFilterFormData(formData) {
  if (formData.filter_type == "month") {
    const start_date = subtractFromDate("month", 1).toISOString().substr(0, 10);
    const end_date = subtractFromDate().toISOString().substr(0, 10);
    formData = {
      filter_type: "month",
      label: "Past Month",
      start_date: start_date,
      end_date: end_date,
    };
  } else if (formData.filter_type == "quarter") {
    const start_date = subtractFromDate("month", 3).toISOString().substr(0, 10);
    const end_date = subtractFromDate().toISOString().substr(0, 10);
    formData = {
      filter_type: "quarter",
      label: "Past Quarter",
      start_date: start_date,
      end_date: end_date,
    };
  } else if (formData.filter_type == "year") {
    const start_date = subtractFromDate("year", 1).toISOString().substr(0, 10);
    const end_date = subtractFromDate().toISOString().substr(0, 10);
    formData = {
      filter_type: "year",
      label: "Past Year",
      start_date: start_date,
      end_date: end_date,
    };
  } else if (formData.filter_type == "custom") {
    formData = {
      filter_type: formData.filter_type,
      label: "Custom",
      start_date: formData.start_date,
      end_date: formData.end_date,
    };
  } else if (formData.filter_type == "upcoming") {
    formData = { filter_type: formData.filter_type, label: "Upcoming" };
  } else {
    const start_date = subtractFromDate("month", 1).toISOString().substr(0, 10);
    const end_date = subtractFromDate().toISOString().substr(0, 10);
    formData = {
      filter_type: "month",
      label: "Past Month",
      start_date: start_date,
      end_date: end_date,
    };
  }
  return formData;
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function findDay(date, lang) {
  let dateToCheck = new Date(date);

  const today = new Date();
  const yesterday = new Date(today);
  const oneDayBeforeYesterday = new Date(yesterday);
  const twoDayBeforeYesterday = new Date(yesterday);
  const threeDayBeforeYesterday = new Date(yesterday);
  const fourDayBeforeYesterday = new Date(yesterday);
  const fiveDayBeforeYesterday = new Date(yesterday);

  yesterday.setDate(yesterday.getDate() - 1);
  oneDayBeforeYesterday.setDate(yesterday.getDate() - 1);
  twoDayBeforeYesterday.setDate(yesterday.getDate() - 2);
  threeDayBeforeYesterday.setDate(yesterday.getDate() - 3);
  fourDayBeforeYesterday.setDate(yesterday.getDate() - 4);
  fiveDayBeforeYesterday.setDate(yesterday.getDate() - 5);

  if (dateToCheck.toDateString() === today.toDateString()) {
    return `Today at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (dateToCheck.toDateString() === yesterday.toDateString()) {
    return `Yesterday at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (
    dateToCheck.toDateString() === oneDayBeforeYesterday.toDateString()
  ) {
    return `${dayOfWeekNames[dateToCheck.getDay()]} at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (
    dateToCheck.toDateString() === twoDayBeforeYesterday.toDateString()
  ) {
    return `${dayOfWeekNames[dateToCheck.getDay()]} at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (
    dateToCheck.toDateString() === threeDayBeforeYesterday.toDateString()
  ) {
    return `${dayOfWeekNames[dateToCheck.getDay()]} at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (
    dateToCheck.toDateString() === fourDayBeforeYesterday.toDateString()
  ) {
    return `${dayOfWeekNames[dateToCheck.getDay()]} at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else if (
    dateToCheck.toDateString() === fiveDayBeforeYesterday.toDateString()
  ) {
    return `${dayOfWeekNames[dateToCheck.getDay()]} at ${formatDate(dateToCheck, "HH:mm aaa")}`;
  } else {
    const startTime = new Intl.DateTimeFormat(lang, {
      timeStyle: "short",
    }).format(dateToCheck);
    const day = new Date(dateToCheck).toLocaleString(lang, {
      weekday: "long",
    });
    const sDate = formatDate(dateToCheck, "yyyy/MM/dd");
    return `${day} ${sDate} at ${startTime}`;
  }
}

export function toHoursAndMinutes(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h${minutes > 0 ? ` ${minutes}m` : ""}`;
}

export function openDocument(url, fileName) {
  var win = window.open();
  var iframe = document.createElement("iframe");
  var title = document.createElement("title");
  title.appendChild(document.createTextNode(fileName));
  iframe.src = url;
  iframe.width = "100%";
  iframe.height = "100%";
  iframe.style.border = "none";

  win.document.head.appendChild(title);
  win.document.body.appendChild(iframe);
  win.document.body.style.margin = 0;
}

export function isURL(str) {
  if (!str) {
    return true;
  }
  let res = str.match(
    /^(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return res !== null;
}

export function getTimeDetails(date) {
  const dueDate = new Date(date);
  const startDate = new Intl.DateTimeFormat(this.selectedLang, {
    dateStyle: "long",
  }).format(dueDate);
  const startTime = new Intl.DateTimeFormat(this.selectedLang, {
    timeStyle: "short",
  }).format(dueDate);
  return `${startDate} ${startTime}`; // November 29, 2023 7:15 PM
}

export function base64ToFile(base64Image, fileName = "image") {
  // Determine MIME type from base64 string
  const mimeType = base64Image.match(/^data:(image\/[a-zA-Z+-.]+);base64,/);
  if (!mimeType) {
    throw new Error("Invalid base64 image string");
  }
  const type = mimeType[1];

  // Create a new FormData object
  let formData = new FormData();

  // Convert the base64 image to a Blob
  const byteCharacters = atob(base64Image.split(",")[1]);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type });

  // Append the Blob to FormData
  formData.append("profilePhoto", blob, `${fileName}.${type.split("/")[1]}`);

  return blob;
}

export function calculateSecondsFromGivenUTCToCurrent(givenUTC) {
  const givenDate = new Date(givenUTC);
  const currentDate = new Date();
  const differenceInMilliseconds = currentDate - givenDate;
  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
  return differenceInSeconds;
}

export function secondsToHMS(seconds) {
  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor((seconds % 3600) / 60);
  var remainingSeconds = Math.floor(seconds % 60);

  // Formatting to add leading zeros if needed
  var hoursStr = hours.toString().padStart(2, "0");
  var minutesStr = minutes.toString().padStart(2, "0");
  var secondsStr = remainingSeconds.toString().padStart(2, "0");

  return hoursStr + ":" + minutesStr + ":" + secondsStr;
}

export function convertTimeToDate(date, timeString) {
  // Split the time string into hours and minutes
  const [hours, minutes] = timeString.split(":").map(Number);

  // Create a new Date object with today's date and the provided hours and minutes
  const currentDate = new Date(date);
  currentDate.setHours(hours);
  currentDate.setMinutes(minutes);
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);
  return currentDate;
}

export function convertDateToTime(date) {
  const currentTime = new Date(date);
  const hours = currentTime.getHours().toString().padStart(2, "0");
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");
  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
}

export function getDateRange(date) {
  const startDate = new Date(date);
  const startMonth = startDate.getMonth();  // Get the start month (0-11)
  const startYear = startDate.getFullYear(); // Get the start year
  // Set the end date to 12 months later
  const endDate = new Date(startYear, startMonth + 11, 1); // Add 11 months
  // Format the start and end date in the desired format (e.g. Jan-2025)
  const options = { year: 'numeric', month: 'short' };
  const startFormatted = startDate.toLocaleDateString('en-US', options).replace(' ', '-');
  const endFormatted = endDate.toLocaleDateString('en-US', options).replace(' ', '-');
  return { from_year: startFormatted, to_year: endFormatted };
}

export function transformTenantGroupData(data) {
  let grp = blankObjectConvertToArray(data.groups);
  const groupsMap = grp.reduce((acc, group, index) => {
    acc[group.id] = {
      id: group.id,
      name: group.name,
      isGroup: true,
      disabled: true,
      tenants: [],
    };
    return acc;
  }, {});

  const ungroupedTenants = [];

  data.tenants.forEach((tenant) => {
    const groupId = tenant.group_id;
    const tenantEntry = {
      id: tenant.id,
      name: tenant.name,
    };

    if (groupId && groupsMap[groupId]) {
      const group = groupsMap[groupId];
      group.tenants.push(tenantEntry);
    } else {
      ungroupedTenants.push({
        id: tenant.id,
        isGroup: false,
        name: tenant.name,
      });
    }
  });

  const groupedTenants = Object.values(groupsMap);
  return [...groupedTenants, ...ungroupedTenants];
}

export function blankObjectConvertToArray(object) {
  return object && Object.keys(object).length > 0 ? object : [];
}

export default {
  getDateRange,
  formatBytes,
  currentDateTime,
  createUUID,
  subtractFromDate,
  addIntoDate,
  getContrast,
  formatDate,
  toHoursAndMinutes,
  convertDateTOFormat,
  unixIntlDateFormat,
  convertIntlDateFormat,
  openDocument,
  getTimeDocumentDateTime,
  isURL,
  getTimeDetails,
  base64ToFile,
  findDay,
  calculateSecondsFromGivenUTCToCurrent,
  secondsToHMS,
  convertTimeToDate,
  convertDateToTime,
  isoIntlDateFormat,
  transformTenantGroupData,
  blankObjectConvertToArray
};
